import React, {useEffect, useState} from "react";
import {useHistory, useLocation} from "react-router-dom";
import {useTable} from "react-table";
import "jspdf-autotable";
import {useForm} from "react-hook-form";
import ConsoleHelper from "../ConsoleHelper";
import axios from "axios";
import {editAccountManagerApi, validateAccountManagerExistsApi} from "../Api";
import CustomOption from "../Utils/CustomOption";
import CustomMenuList from "../Utils/CustomMenuList";
import Select, {createFilter} from "react-select";

function AccountManagerBank(props) {
    const [isEditable, setIsEditable] = useState(false);
    const [buttonText, setButtonText] = useState("Save");
    const loggedUserStorage = sessionStorage.getItem('loggedUserStorage');
    const [data, setData] = useState([]);
    const [paramBankName, setParamBankName] = useState();
    const [paramBranchAddress, setParamBranchAddress] = useState();
    const [paramBankPostalCode, setParamBankPostalCode] = useState([]);
    const [paramBankPhone, setParamBankPhone] = useState();
    const [paramBankCountry, setParamBankCountry] = useState();
    const [country, setCountry] = useState();
    const [countryData, setCountryData] = useState();
    const [paramBranchCity, setParamBranchCity] = useState();
    const [paramBranchRegion, setParamBranchRegion] = useState();
    const [paramBranchPostalCode, setParamBranchPostalCode] = useState();
    const [consolidationType, setConsolidationType] = useState();
    const [paramBranchPhone, setParamBranchPhone] = useState();
    const [paramHolderName, setParamHolderName] = useState();
    const [paramHolderAddress, setParamHolderAddress] = useState();
    const [paramHolderCity, setParamHolderCity] = useState();
    const [paramHolderPostalCode, setParamHolderPostalCode] = useState([]);
    const [paramHolderPhone, setParamHolderPhone] = useState();
    const [paramHolderCountry, setParamHolderCountry] = useState();
    const [paramHolderRegion, setParamHolderRegion] = useState();
    const [rtaNumber, setRtaNumber] = useState();
    const [accountType, setAccountType] = useState();
    const [paramStatus, setParamStatus] = useState();
    const [paramConsolidationType, setParamConsolidationType] = useState();
    const [approvalFlag, setApprovalFlag] = useState(0);
    const [currentStatus, setCurrentStatus] = useState();
    const [resetUserForm, setResetUserForm] = useState(false);
    const [paramAccountID, setParamAccountID] = useState();
    const history = useHistory();
    const location = useLocation();

    const {
        reset,
        formState: { errors }
    } = useForm();

    const handleReturnOperation = async (e) => {
        setIsEditable(true);
        setButtonText("Save")
    };


    useEffect(() => {
        ConsoleHelper("history bank",history.location.state?.from?.split("?")[1])
        let rtaFromLoc = (history.location.state?.from?.split("?")[1]?.split("=")?.[1]?.split("&")?.[0])?.replace(/[^\w @]/g, '');
        let paramAccountIDLoc = history.location.state?.from?.split("?")[1]?.split("=")?.[2]?.replace(/[^\w @]/g, '');
        console.log(rtaFromLoc," ---- ",paramAccountIDLoc)
        //setRta and account number
        setRtaNumber(rtaFromLoc);
        setParamAccountID(paramAccountIDLoc);

        console.log(rtaNumber," ---=-=BANK-==-=- ",paramAccountID)
        history.push({
            pathname: "/accountManager/bank",
            search: `rta=${rtaFromLoc}&AccountID=${paramAccountIDLoc}`,
        });

        return () => {
        };
    }, [resetUserForm]);


    useEffect(() => {
        const getAccountDetails = async () => {
            const searchVal = location?.search?.split("=");
            setButtonText("Save");
            let rtaFromLoc = (location?.search?.split("=")?.[1].split("&")?.[0]).replace(/[^\w @]/g, '');
            let paramAccountIDLoc = (location?.search?.split("=")?.[2].split("&")?.[0]).replace(/[^\w @]/g, '');
            setRtaNumber(rtaFromLoc);
            setParamAccountID(paramAccountIDLoc);
            ConsoleHelper(rtaFromLoc,"<----rta for Bank  acountId---->",paramAccountIDLoc);
            ConsoleHelper(" GET USERS BY LIST WITH ID",rtaNumber)
            const getAccountPropertiesDetails = await axios.get(`${validateAccountManagerExistsApi}?paramRTA=${(location?.search?.split("=")?.[1].split("&")?.[0]).replace(/[^\w @]/g, '')}&paramUserID=${loggedUserStorage}`);
            ConsoleHelper(" is valid account manager  data ",getAccountPropertiesDetails?.data?.response[0]);

            if(getAccountPropertiesDetails?.data?.response.length >0 ){
                setButtonText("Edit");
                setIsEditable(false);
                let accountTypeLbl = getAccountPropertiesDetails?.data?.response[0]?.accountType === "SAV"? "Savings":"Checking"
                setAccountType({
                    label: accountTypeLbl,
                    value: getAccountPropertiesDetails?.data?.response[0]?.accountType,
                });
                setCountry({
                    label: getAccountPropertiesDetails?.data?.response[0]?.branchCountry,
                    value: getAccountPropertiesDetails?.data?.response[0]?.branchCountry,
                });
                setParamHolderRegion({
                    label: getAccountPropertiesDetails?.data?.response[0]?.holderRegion,
                    value: getAccountPropertiesDetails?.data?.response[0]?.holderRegion,
                });
                setApprovalFlag(getAccountPropertiesDetails?.data?.response[0]?.requireApproval);//

                let currentStatusLbl = getAccountPropertiesDetails?.data?.response[0]?.status === "AC"? "Active":
                    (getAccountPropertiesDetails?.data?.response[0]?.status === "CD"?"Closed":
                        (getAccountPropertiesDetails?.data?.response[0]?.status === "PK"?"Deleted":""));
                setCurrentStatus({
                    label: currentStatusLbl,
                    value: getAccountPropertiesDetails?.data?.response[0]?.status,
                });//
                setParamHolderName(getAccountPropertiesDetails?.data?.response[0]?.holderName);
                setParamHolderAddress(getAccountPropertiesDetails?.data?.response[0]?.holderAddress);
                setParamHolderCity(getAccountPropertiesDetails?.data?.response[0]?.holderCity);
                setParamHolderPostalCode(getAccountPropertiesDetails?.data?.response[0]?.holderPostalCode);
                setParamHolderPhone(getAccountPropertiesDetails?.data?.response[0]?.holderPhone);
                setConsolidationType([
                    { label: getAccountPropertiesDetails?.data?.response[0]?.consolidationTypeDesc, value: getAccountPropertiesDetails?.data?.response[0]?.consolidationType },
                ]);
                setParamBankName(getAccountPropertiesDetails?.data?.response[0]?.bankName);
                setParamBranchAddress(getAccountPropertiesDetails?.data?.response[0]?.branchAddress);
                setParamBranchCity(getAccountPropertiesDetails?.data?.response[0]?.branchCity);
                setParamBranchRegion(getAccountPropertiesDetails?.data?.response[0]?.branchRegion);
                setParamBankPostalCode(getAccountPropertiesDetails?.data?.response[0]?.branchPostalCode);
                setParamBankPhone(getAccountPropertiesDetails?.data?.response[0]?.branchPhone);

            }


        };

        setCountryData([
            { label: "Select Country", value: "NA" },
            { label: "United States", value: "USA" },
            { label: "Mexico", value: "MEX" },
            { label: "Canada", value: "CAN" },
            { label: "India", value: "IND" },
            { label: "United Kingdom", value: "UK" },
            { label: "Europe ", value: "EUR" },
        ]);


        if( (typeof location?.search?.split("=")?.[1] !== "undefined")){
            getAccountDetails();
        }
        return () => {
            setData([]);
            // setUserOptions([]);

        };
    }, [location]);


    const handleGetReport = async () => {
        try {
            const paramSettlementACHFileID = '1';
            const paramSettlementScheduleType = '0';
            const paramSettlementScheduleDay = '0';
            const paramSettlementThresholdAmount = '0';
            const paramSurchargeACHFileID = '1';
            const paramSurchargeScheduleType = '0';
            const paramSurchargeScheduleDay = '0';
            const paramSurchargeThresholdAmount = '0';
            const paramInterchangeACHFileID = '1';
            const paramInterchangeScheduleType = '0';
            const paramInterchangeScheduleDay = '0';
            const paramInterchangeThresholdAmount = '0';
            const paramComment = '';
            const paramResponse= '-1';
            const paramSettlementSchedulePayoutDay = '1';
            const paramSurchargeSchedulePayoutDay = '1';
            const paramInterchangeSchedulePayoutDay = '1';

            ConsoleHelper(" ----- rta at holder",rtaNumber)
            const result = await axios.get(`${validateAccountManagerExistsApi}?paramRTA=${rtaNumber}&paramUserID=${loggedUserStorage}`);
            ConsoleHelper(" is valid account manager  data ",result?.data?.response[0]);


            if(result?.data?.response.length >0 ){
                setButtonText("Save");
                setIsEditable(true);
                setAccountType(result?.data?.response[0]?.accountType);
                setParamConsolidationType(result?.data?.response[0]?.consolidationType);
                setParamStatus(result?.data?.response[0]?.status);
                setParamAccountID(result?.data?.response[0]?.accountID)
                setParamHolderName(result?.data?.response[0]?.holderName);
                setParamHolderAddress(result?.data?.response[0]?.holderAddress);
                setParamHolderCity(result?.data?.response[0]?.holderCity);
                setParamHolderRegion(result?.data?.response[0]?.holderRegion);
                setParamHolderCountry(result?.data?.response[0]?.holderCountry);
                setParamHolderPostalCode(result?.data?.response[0]?.holderPostalCode);
                setParamBankName(result?.data?.response[0]?.bankName);
                setParamBranchAddress(result?.data?.response[0]?.branchAddress);
                setParamBranchCity(result?.data?.response[0]?.branchCity);
                setParamBranchRegion(result?.data?.response[0]?.branchRegion);
                setParamBankPostalCode(result?.data?.response[0]?.branchPostalCode);
                setParamBankPhone(result?.data?.response[0]?.branchPhone);
            }

            /*console.log(" bankName ",paramBankName)
            console.log(" bankAddress ",paramBranchAddress)
            ConsoleHelper(" paramBankCity ",paramBranchCity);
            ConsoleHelper(" paramBankRegion ",paramBranchRegion);
            ConsoleHelper(" paramBankCountry ",paramBankCountry);
            ConsoleHelper(" paramBankPostalCode ",paramBankPostalCode);
            ConsoleHelper(" paramBankPhone ",paramBankPhone);
            ConsoleHelper(" accountType ",accountType);
            ConsoleHelper(" paramConso ",paramConsolidationType);
            ConsoleHelper(" paramStatus ",paramStatus);*/
            const headers= {"Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Methods":"*",
                "Access-Control-Allow-Headers":"*",
            };
            const editAccountManagerResult = await axios.get(`${editAccountManagerApi}?paramAccountID=${paramAccountID}&paramHolderName=${paramHolderName}&paramRTA=${rtaNumber}&paramAccountType=${accountType?.value}&paramConsolidationType=${consolidationType?.value}&paramUserIDOwner=${loggedUserStorage}&paramResponse=${paramResponse}&paramRequireApproval=${approvalFlag}&paramStatus=${currentStatus?.value}&paramSettlementACHFileID=${paramSettlementACHFileID}&paramSettlementScheduleType=${paramSettlementScheduleType}&paramSettlementScheduleDay=${paramSettlementScheduleDay}&paramSettlementThresholdAmount=${paramSettlementThresholdAmount}&paramSurchargeACHFileID=${paramSurchargeACHFileID}&paramSurchargeScheduleType=${paramSurchargeScheduleType}&paramSurchargeScheduleDay=${paramSurchargeScheduleDay}&paramSurchargeThresholdAmount=${paramSurchargeThresholdAmount}&paramInterchangeACHFileID=${paramInterchangeACHFileID}&paramInterchangeScheduleType=${paramInterchangeScheduleType}&paramInterchangeScheduleDay=${paramInterchangeScheduleDay}&paramInterchangeThresholdAmount=${paramInterchangeThresholdAmount}&paramBankName=${paramBankName}&paramBranchAddress=${paramBranchAddress}&paramBranchCity=${paramBranchCity}&paramBranchRegion=${paramBranchRegion}&paramBranchCountry=${country?.value}&paramBranchPostalCode=${paramBranchPostalCode}&paramBranchPhone=${paramBranchPhone}&paramHolderAddress=${paramHolderAddress}&paramHolderCity=${paramHolderCity}&paramHolderRegion=${paramHolderRegion?.value}&paramHolderCountry=${country?.value}&paramHolderPostalCode=${paramHolderPostalCode}&paramHolderPhone=${paramHolderPhone}&paramComment=${paramComment}&paramCurrentUserID=${loggedUserStorage}&paramSettlementSchedulePayoutDay=${paramSettlementSchedulePayoutDay}&paramSurchargeSchedulePayoutDay=${paramSurchargeSchedulePayoutDay}&paramInterchangeSchedulePayoutDay=${paramInterchangeSchedulePayoutDay}`,
                {headers},
                { crossdomain: true });
            ConsoleHelper(" Edit Result data ",editAccountManagerResult?.data?.response);
            setButtonText("Save")
            setIsEditable(false)
        } catch (error) {}
    };
    return (
        <div>
            <div className="row">
                <div className="col-md-12">
                    <h5 className="tbsub-title mt-3 mb-3">Bank and Branch Information</h5>
                    <form>
                        <div className="row mt-4">
                            <div className="col col-md-5">
                                <div className="d-flex justify-content-between">
                                    <label>Bank Name:</label>
                                    <div>
                                        <input
                                            type="text"
                                            className="form-control form-control-sm col-md-12"
                                            style={{width: "15.5vw"}}
                                            placeholder={"Bank Name"}
                                            readOnly={!isEditable}
                                            defaultValue={paramBankName}
                                            onChange={(e) =>
                                                setParamBankName(
                                                    (e.target.value)
                                                )
                                            }
                                        />
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="row mt-2">
                            <div className="col col-md-5">
                                <div className="d-flex justify-content-between ">
                                    <label>Bank Address:</label>
                                    <div>
                                        <input
                                            type="text"
                                            className="form-control form-control-sm col-md-12"
                                            style={{width: "15.5vw"}}
                                            placeholder={"Bank Address"}
                                            readOnly={!isEditable}
                                            defaultValue={paramBranchAddress}
                                            onChange={(e) =>
                                                setParamBranchAddress(
                                                    (e.target.value)
                                                )
                                            }
                                        />
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="row mt-2">
                            <div className="col col-md-5">
                                <div className="d-flex justify-content-between align-items-center">
                                    <label>Bank City:</label>
                                    <div>
                                        <input
                                            type="text"
                                            className="form-control form-control-sm col-md-12"
                                            style={{width: "15.5vw"}}
                                            placeholder={"Bank City"}
                                            readOnly={!isEditable}
                                            defaultValue={paramBranchCity}
                                            onChange={(e) =>
                                                setParamBranchCity(
                                                    (e.target.value)
                                                )
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/*  */}
                        <div className="row mt-2">
                            <div className="col col-md-5">
                                <div className="d-flex justify-content-between align-items-center">
                                    <label>Bank Region:</label>
                                    <div>
                                        <select readOnly={!isEditable} name="paramRegion" onChange={(e) =>setParamBranchRegion((e.target.value))}
                                                className="form-control form-control-sm col-md-12" style={{width: "15.5vw"}}>
                                            <option value="14">Alaska</option>
                                            <option value="15">Alabama</option>
                                            <option value="16">Arkansas</option>
                                            <option value="17">Arizona</option>
                                            <option  value="18">California</option>
                                            <option value="19">Colorado</option>
                                            <option value="20">Connecticut</option>
                                            <option value="21">District of Columbia</option>
                                            <option value="22">Delaware</option>
                                            <option value="23">Florida</option>
                                            <option value="24">Georgia</option>
                                            <option value="25">Hawaii</option>
                                            <option value="26">Iowa</option>
                                            <option value="27">Idaho</option>
                                            <option value="28">Illinois</option>
                                            <option value="29">Indiana</option>
                                            <option value="30">Kansas</option>
                                            <option value="31">Kentucky</option>
                                            <option value="32">Louisiana</option>
                                            <option value="33">Massachusetts</option>
                                            <option value="34">Maryland</option>
                                            <option value="35">Maine</option>
                                            <option value="36">Michigan</option>
                                            <option value="37">Minnesota</option>
                                            <option value="38">Missouri</option>
                                            <option value="39">Mississippi</option>
                                            <option value="40">Montana</option>
                                            <option value="41">North Carolina</option>
                                            <option value="42">North Dakota</option>
                                            <option value="43">Nebraska</option>
                                            <option value="44">New Hampshire</option>
                                            <option value="45">New Jersey</option>
                                            <option value="46">New Mexico</option>
                                            <option value="47">Nevada</option>
                                            <option value="48">New York</option>
                                            <option value="49">Ohio</option>
                                            <option value="50">Oklahoma</option>
                                            <option value="51">Oregon</option>
                                            <option value="52">Pennsylvania</option>
                                            <option value="53">Rhode Island</option>
                                            <option value="54">South Carolina</option>
                                            <option value="55">South Dakota</option>
                                            <option value="56">Tennessee</option>
                                            <option value="57">Texas</option>
                                            <option value="58">Utah</option>
                                            <option value="59">Virginia</option>
                                            <option value="60">Vermont</option>
                                            <option value="61">Washington</option>
                                            <option value="62">Wisconsin</option>
                                            <option value="63">West Virginia</option>
                                            <option value="64">Wyoming</option>
                                        </select>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="row mt-2">
                            <div className="col col-md-5">
                                <div className="d-flex justify-content-between ">
                                    <label>Bank Country:</label>
                                    <div>
                                        <Select
                                            options={countryData}
                                            isDisabled={!isEditable}
                                            filterOption={createFilter({ ignoreAccents: false })}
                                            captureMenuScroll={false}
                                            classNamePrefix="custom-select"
                                            components={{ Option: CustomOption, MenuList: CustomMenuList }}
                                            value={country}
                                            onChange={(e) =>setCountry((e))}
                                            styles={{
                                                container: (provided) => ({
                                                    ...provided,
                                                    flex: 1,
                                                    width: "15.5vw",
                                                }),
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row mt-2">
                            <div className="col col-md-5">
                                <div className="d-flex justify-content-between align-items-center">
                                    <label>PostalCode:</label>
                                    <div>
                                        <input
                                            type="text"
                                            className="form-control form-control-sm col-md-12"
                                            style={{width: "15.5vw"}}
                                            placeholder={"Zip Code"}
                                            readOnly={!isEditable}
                                            defaultValue={paramBankPostalCode}
                                            onChange={(e) =>
                                                setParamBankPostalCode(
                                                    (e.target.value)
                                                )
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row mt-2">
                            <div className="col col-md-5">
                                <div className="d-flex justify-content-between align-items-center">
                                    <label>Bank Phone:</label>
                                    <div>
                                        <input
                                            type="text"
                                            readOnly={!isEditable}
                                            className="form-control form-control-sm"
                                            style={{width: "15.5vw"}}
                                            onChange={(e) =>
                                                setParamBankPhone(
                                                    (e.target.value)
                                                )
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row d-flex justify-content-center mt-1 align-items-center">
                            {!isEditable ? (
                                <div  className="d-flex justify-content-center">
              <span
                  className="input-group-text"
                  role="button"
                  onClick={() => handleReturnOperation()}>Edit</span>
                                </div>
                            ) : (
                                <span
                                    className="input-group-text"
                                    role="button"
                                    onClick={() => handleGetReport()}>Save</span>
                            )}
                        </div>
                    </form>
                </div>
                {/*  */}
            </div>
        </div>
    );
}

export default AccountManagerBank;
